module.exports = __webpack_public_path__ + "static/media/10.57cf1ea8.jpg";